import Button from '@pinecast/common/Button';
import Group, {VerticalGroup} from '@pinecast/common/Group';
import {OptionButtonWithRadio} from '@pinecast/common/OptionButton';
import {DashboardTitle, P} from '@pinecast/common/Text';
import {defineMessages, FormattedMessage} from '@pinecast/i18n';
import {useCSS} from '@pinecast/styles';
import * as React from 'react';

const messages = defineMessages({
  label: {
    id: 'db-spa.TipFrequency.label',
    description: 'Label for subscription duration',
    defaultMessage:
      'Subscribe for one month or set up a recurring subscription?',
  },
  optionOneTime: {
    id: 'db-spa.TipFrequency.option.oneTime',
    description: 'Label for option to send a one-month subscription',
    defaultMessage: 'Just one month',
  },
  optionRecurring: {
    id: 'db-spa.TipFrequency.option.recurring',
    description: 'Label for option to become a recurring donor',
    defaultMessage: 'Recurring monthly',
  },
  copy: {
    id: 'db-spa.TipFrequency.copy',
    description: 'Copy for how often tips are charged',
    defaultMessage:
      'You can change or cancel a subscription at any time. No surprises.',
  },
  continueButton: {
    id: 'db-spa.TipFrequency.continueButton',
    description: 'Button to move to the next step',
    defaultMessage: 'Continue',
  },
});

type Frequency = 'oneTime' | 'recurring';

const TipFrequency = ({
  onChange,
}: {
  onChange: (frequency: Frequency) => void;
}) => {
  const css = useCSS();

  const [option, setOption] = React.useState<Frequency | null>(null);
  const [pending, setPending] = React.useState(false);
  return (
    <>
      <DashboardTitle>
        <FormattedMessage {...messages.label} />
      </DashboardTitle>
      <VerticalGroup spacing={16}>
        <Group role="radiogroup" spacing={8} wrapperStyle={{marginTop: '-8px'}}>
          <OptionButtonWithRadio
            alignInput="top"
            name="tjfreq"
            onClick={() => {
              setOption('oneTime');
            }}
            selected={option === 'oneTime'}
          >
            <FormattedMessage {...messages.optionOneTime} />
          </OptionButtonWithRadio>
          <OptionButtonWithRadio
            alignInput="top"
            name="tjfreq"
            onClick={() => {
              setOption('recurring');
            }}
            selected={option === 'recurring'}
          >
            <FormattedMessage {...messages.optionRecurring} />
          </OptionButtonWithRadio>
        </Group>
        <P>
          <FormattedMessage {...messages.copy} />
        </P>
        <div className={css({display: 'flex', justifyContent: 'flex-end'})}>
          <Button
            disabled={option === null}
            onClick={() => {
              onChange(option!);
              setPending(true);
            }}
            pending={pending}
          >
            <FormattedMessage {...messages.continueButton} />
          </Button>
        </div>
      </VerticalGroup>
    </>
  );
};

export default TipFrequency;
